import { Controller } from "@hotwired/stimulus"

// Mobile-only disclosure for a calendar filter group ("Filtrer på sted" /
// "Filtrer på kategori"). Disclosure pattern (WCAG 2.1 AA): a real <button>
// with aria-expanded controls the chip region via aria-controls; collapsed
// content is display:none so it is removed from the tab order and the
// accessibility tree. On desktop the panel is always shown (md:flex) and the
// trigger is hidden (md:hidden), so this controller only drives the phone
// layout.
//
// The chips live inside the events-list Turbo Frame, which re-renders on
// every selection, so the open/closed state is kept in sessionStorage (keyed
// by the panel id) and restored on connect — picking several chips in a row
// no longer slams the group shut between submits.
export default class extends Controller {
  static targets = ["trigger", "panel", "icon"]

  connect() {
    if (this.stored === "open") this.open({ persist: false })
  }

  toggle() {
    this.expanded ? this.close() : this.open()
  }

  open({ persist = true } = {}) {
    this.panelTarget.classList.remove("hidden")
    this.triggerTarget.setAttribute("aria-expanded", "true")
    if (this.hasIconTarget) this.iconTarget.classList.add("rotate-180")
    if (persist) this.store("open")
  }

  close() {
    this.panelTarget.classList.add("hidden")
    this.triggerTarget.setAttribute("aria-expanded", "false")
    if (this.hasIconTarget) this.iconTarget.classList.remove("rotate-180")
    this.store("closed")
  }

  get expanded() {
    return this.triggerTarget.getAttribute("aria-expanded") === "true"
  }

  get key() {
    return `filter-disclosure:${this.panelTarget.id}`
  }

  get stored() {
    try { return window.sessionStorage.getItem(this.key) } catch { return null }
  }

  store(value) {
    try { window.sessionStorage.setItem(this.key, value) } catch (_) { /* private mode */ }
  }
}
